// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22xtu","left":"styles_left__rYS72"};